/**
 * Application constant's
 */

export const HOME_PAGE_HEADER_CONST_HEIGHT = 80;
export const HOME_PAGE_HEADER_HEIGHT = 112;
export const MEETINGS_AND_EVENTS = 'Meetings';
export const submitSearchURL = '/search/submitSearch.mi';
export const availabilitySearchUrl = '/reservation/availabilitySearch.mi';
export const meetingsSubmitURL = '/meetings/search-hotels.mi';
export const clickTrackTabbedSFTitle = 'Phoenix Advance Search ';
export const clickTrackMeetingEventsTitle = 'Meeting Search Form';
export const clickTrackMeetingEventsPurpose = 'Event purpose';
export const clickTrackMeetingEventsFindBtn = 'Meeting Search Form | Find Hotels | internal';
export const localeToRemoveFromURL = ['tr', 'pl', 'id', 'zh'];
export const tabIcons = {
  'Baseline Search Form': 'icon-city',
  Meetings: 'icon-meeting-services-app',
};
export const RATES_DATA = 'ratesData';
export const RATES_DATA_FOR_SELECTED_PROPERTY = 'ratesDataForSelectedProperty';
export const PROPERTY_INFO_DATA = 'propertyInfoData';
export const SEARCH_RESULTS_ALERTS = 'searchResultsAlerts';
export const SESSION_DATA_VALUES = 'sessionDataValues';
export const EEO_TYPE = 'eeo';
export const NO_RATES_ARE_AVAILABLE = 'noRatesAreAvailable';
export const TOO_MANY_PROPERTIES = 'tooManyProperties';
